import React from 'react'
import { useDispatch } from 'react-redux';
import CamIconWithRibbon from '@surfline/quiver-react/dist/icons/CamIconWithRibbon';
import Button from '@surfline/quiver-react/dist/Button';
import en from '../../intl/translations/en'
import { clickedSubscribeCTA } from '../../actions/segmentEvents';
import { assignLocation } from '../../utils/assignLocation';

const MultiCamPaywall = () => {
  const dispatch = useDispatch();

  const doClickedSubscribe = () => {
    dispatch(clickedSubscribeCTA({ ctaLocation: `Multi Cam Page`, pageName: 'multi-cam', category: 'cams & reports' }))
    assignLocation('/upgrade');
  }

  const copy = en.MultiCam.paywall;

  return (
    <div className="sl-multi-cam-paywall">
      <CamIconWithRibbon isFilled isMulti />
      <h1 className="sl-multi-cam-paywall__header">{copy.header}</h1>
      <Button onClick={doClickedSubscribe}>{copy.goPremium}</Button>
      <a className="sl-multi-cam-paywall__link" href="/premium-benefits">{copy.link}</a>
    </div>
  )
}

MultiCamPaywall.propTypes = {

}

export default MultiCamPaywall
